import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { mensaService } from '../../gestione-mensa.service';

@Component({
  selector: 'app-ricette-edit',
  templateUrl: './ricette-edit.component.html',
  styleUrls: ['./ricette-edit.component.css'],
  providers: [MessageService],
})
export class RicetteEditComponent implements OnInit {
 
  
  pageTitle:string="Nuova ricetta";
  backUrl:string='dashboard/gestionemensa/ricette';
  action:any='';
  camerasList:any=[];
  loading:boolean = true;
  selectedItems:any[]=[];
  model:any={
    struttura_id:0,
    nome:'',
    tipo:'',
    descrizione:'',
    ingredienti:'',
    allergeni:''

  };

  tipopiattiList=[];
  

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    private mensaservice: mensaService,
  ) { }


  ngOnInit(): void {
  
    this.tipopiattiList=this.mensaservice.getTipiPiatti(); 
    this.action=this.route.snapshot.paramMap.get('action');
  
    
    if(this.route.snapshot.paramMap.get('id')){
      this.pageTitle="Modifica ricetta";
      this.apiService.post('mensa/mensa_ricette_getall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.model = data2.Result[0];
        
      });
    }
 
  }

  valida(){
    return true;
  }

  salva(){
    this.apiService.post('mensa/mensa_ricetta_update',this.model).subscribe(data => {
      this.addSingle('success', 'Successo', 'Record aggiornato ');
      this.router.navigateByUrl(this.backUrl);
    });
  }
  
  delete(){

  }

  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  
  
  
}
